export async function fetchRemoteWriteKey() {
    try {
        const res = await fetch("https://ws-accounkit-assets.s3.us-west-1.amazonaws.com/logger_config_v1.json");
        const json = await res.json();
        return json.writeKey;
    }
    catch (e) {
        console.warn("failed to fetch write key");
        return undefined;
    }
}
//# sourceMappingURL=fetchRemoteWriteKey.js.map